module.exports = __webpack_public_path__ + "823edf36568f57d702bcccf9d03c10ce.gif";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/loader/img/loader.gif
// module id = 15
// module chunks = 0 1 3 4